import React from 'react';
import { Box } from '@mui/material';

// Native controls inherit disabled; inert also blocks custom controls such as
// Select. React capture guards cover menus and calendars rendered in portals.
export default function DisabledFieldset({ disabled, children, sx }) {
  const stopEditing = event => {
    if (!disabled) return;
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Box
      component="fieldset"
      disabled={disabled}
      inert={disabled ? '' : undefined}
      onClickCapture={stopEditing}
      onMouseDownCapture={stopEditing}
      onKeyDownCapture={stopEditing}
      onChangeCapture={stopEditing}
      sx={{ border: 0, padding: 0, margin: 0, minWidth: 0, ...sx }}
    >
      {children}
    </Box>
  );
}
